// src/controllers/drag_controller.js
import { Controller } from "@hotwired/stimulus";
import { Sortable, MultiDrag } from 'sortablejs'

/**
 * Stimulus controller for drag-and-drop sorting using SortableJS with MultiDrag.
 * Handles UI updates and AJAX position persistence.
 */
export default class extends Controller {
  static values = { url: String, refreshInterval: Number }

  /**
   * Called when the controller is connected to the DOM.
   * Initializes SortableJS with multi-drag and sets up event handlers.
   */
  connect() {
    try {
      // Mount MultiDrag plugin if available (Sortable 1.10+)
      Sortable?.mount(new MultiDrag())
    } catch (error) {
      console.log('sortable error: ' + error)
    }

    this.sortable = Sortable.create(this.element, {
      multiDrag: true,
      handle: '.drag-handle',
      onUpdate: this.end.bind(this),
      selectedClass: "bg-warning"
    });
  }

  /**
   * Called when the controller is disconnected from the DOM.
   * Destroys the Sortable instance.
   */
  disconnect() {
    this.sortable.destroy()
  }

  /**
   * Handler for when the sort order changes.
   * Gathers new item order and triggers AJAX update.
   * @param {SortableEvent} event
   */
  end(event) {
    let all_items = this.getAllItems(event)
    this.element.classList.add('processing')
    this.updatePosition(all_items, this.element)
  }

  /**
   * Returns an array of all items and their new positions after sort.
   * @param {SortableEvent} event
   * @returns {Array<{id: string, position: number}>}
   */
  getAllItems(event) {
    let items = []
    for (let item of event.to.children) {
      items.push({ id: item.dataset.id, position: Sortable.utils.index(item, '>*') + 1 })
    }
    return items
  }

  /**
   * Sends the new order to the server via AJAX and updates UI state.
   * @param {Array} data - Array of {id, position} objects
   * @param {Element} element - The container element
   */
  updatePosition(data, element) {
    Rails.ajax({
      url: this.data.get("url"),
      type: 'POST',
      data: JSON.stringify(data),
      success: function () {
        element.classList.remove('processing')
      }
    });
  }
}
